import { Box, Container } from "@mui/material";
import { useLocation } from "react-router-dom";
import React, { useMemo } from "react";
import TextCarousel from "./common/TextCarousel";
import { useTranslation } from "react-i18next";
import i18nContent from "../utils/i18nContent";

const SeoContent = () => {
    const location = useLocation();
    const { t } = useTranslation("", {
        i18n: i18nContent,
        useSuspense: false,
    });

    const key = `${location.pathname}.pageContent`;
    const content = t(key, { defaultValue: "" });

    const htmlSlides = useMemo(() => {
        if (!content) return [];
        return [
            <>
                <div
                    mt={2}
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </>,
        ];
    }, [content]);

    if (!content) return null;

    return (
        <Container>
            <Box pt={{ xs: 4, sm: 4, md: 4 }} pb={{ xs: 11, sm: 5, md: 5 }}>
                <TextCarousel
                    html={htmlSlides}
                    slidesPerView={1}
                    pagination
                    spaceBetween={0}
                />
            </Box>
        </Container>
    );
};

export default SeoContent;
